import { Box } from "@mui/material";
import { useContext, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import backgroundImage from "../Assets/Images/background.jpg";
import { ColorScheme } from "../Themes/ColorScheme";
import { ApiContext } from "./ApiContext";
import { Spinner } from "./Common/Spinner";
import { UserContext } from "./UserContext";

export const LaunchInit = () => {
	const debug = false;

	const { setUser } = useContext(UserContext);
	const { ApiCall } = useContext(ApiContext);

	const navigate = useNavigate();

	const styles = {
		paperContainer: {
			background: "linear-gradient(to bottom, " + ColorScheme.primary + "," + ColorScheme.black + ")", // Gradient background
			minHeight: "100%",
			position: "fixed",
			width: "100%",
			height: "100%",
			top: "0",
			left: "0",
			backgroundImage: `url(${backgroundImage})`,
			backgroundSize: "cover", // Make the image cover the container
			backgroundPosition: "center", // Center the image
			backgroundRepeat: "no-repeat", // Prevent tiling
			boxShadow: "inset 0px 0px 0px 1500px " + ColorScheme.black + ColorScheme.opacity50 // Dark overlay
		}
	};

	useEffect(() => {
		ApiCall("GET", "user", null, navigate)
			.then((res) => {
				setUser(res);
				if (res.name === "") navigate("/details");
				else navigate("/locations"); // navigate("/locations");
			})
			.catch((err) => {
				if (debug) console.log(err);
			});
	}, []);

	return (
		<>
			<div style={styles.paperContainer} />
			<Box
				sx={{
					height: "100vh",
					width: "100vw",
					zIndex: 999,
					position: "absolute",
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					left: 0,
					top: 0
				}}
			>
				<Spinner color={"white"} />
			</Box>
		</>
	);
};
